;(function() {
  'use strict'

  Controller.$inject = ["glDialog", "quotaCellsService", "quotaTextService", "Question", "QuotaDefinition", "QuotaVariable"];
  angular.module('app.core').component('quotaVariablesDialog', {
    controller: Controller,
    templateUrl: 'quota-variables-dialog.html',
    bindings: {
      quota: '<',
      plan: '<',
      questions: '<',
      tagCounts: '<',
      surveyTags: '<',
      responseCount: '<',
      onApply: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller(
    glDialog,
    quotaCellsService,
    quotaTextService,
    Question,
    QuotaDefinition,
    QuotaVariable
  ) {
    var ctrl = this

    var MAX_NAME_LENGTH = 50
    var SEARCH_THRESHOLD = 10
    var TAG_SUMMARY_LIMIT = 3
    var MAX_CELLS = 500

    var pluralise = quotaTextService.pluralise
    var originalDerivedName = null

    ctrl.maxLength = MAX_NAME_LENGTH

    ctrl.$onInit = onInit

    ctrl.matchesQuery = matchesQuery
    ctrl.hasNothingToOffer = hasNothingToOffer
    ctrl.isEverythingUsed = isEverythingUsed
    ctrl.toggle = toggle
    ctrl.buildTagVariable = buildTagVariable
    ctrl.getError = getError
    ctrl.canApply = canApply
    ctrl.apply = apply

    function onInit() {
      originalDerivedName = ctrl.quota.getDerivedName(ctrl.questions)
      ctrl.name = ctrl.quota.name === originalDerivedName ? '' : ctrl.quota.name
      ctrl.query = null
      buildItems()
      refresh()
    }

    function buildItems() {
      var items = []
      var questions = ctrl.questions || []

      questions.forEach(function(question) {
        var existing = _.find(ctrl.quota.variables, function(variable) {
          return variable.isQuestion() && variable.questionId === question.id
        })
        if (!existing && !isOfferable(question)) return

        var owner = findOwnerQuota(question.id)

        items.push({
          key: 'q:' + question.id,
          label: getQuestionLabel(question),
          sub: null,
          selected: !!existing,
          reason: !existing && owner ? 'in ' + owner.name : null,
          variable: existing || null,
          question: question,
          optionCount: getQuestionOptionCount(question, existing),
        })
      })

      _.filter(ctrl.quota.variables, function(variable) {
        return variable.isTag()
      }).forEach(function(variable) {
        items.push(makeTagItem(variable))
      })

      _.filter(ctrl.quota.variables, function(variable) {
        return (
          variable.isQuestion() &&
          !_.find(questions, { id: variable.questionId })
        )
      }).forEach(function(variable) {
        items.push({
          key: 'v:' + variable.id,
          label: 'A question that is no longer in this survey',
          sub: null,
          selected: true,
          reason: null,
          variable: variable,
          question: null,
          optionCount: 0,
        })
      })

      ctrl.items = items
      ctrl.showSearch = items.length > SEARCH_THRESHOLD
    }

    function makeTagItem(variable) {
      var tags = _.map(variable.options, 'tag')

      return {
        key: 'v:' + variable.id,
        label: variable.displayName,
        sub:
          'tags: ' +
          tags.slice(0, TAG_SUMMARY_LIMIT).join(', ') +
          (tags.length > TAG_SUMMARY_LIMIT ? ', …' : ''),
        selected: true,
        reason: null,
        variable: variable,
        question: null,
        optionCount: tags.length,
      }
    }

    function isOfferable(question) {
      return question.type === Question.Types.CHOICE
    }

    function findOwnerQuota(questionId) {
      var others = _.filter(ctrl.plan ? ctrl.plan.getQuotas() : [], function(
        quota
      ) {
        return quota.id !== ctrl.quota.id
      })

      return (
        _.find(others, function(quota) {
          return _.some(quota.variables, function(variable) {
            return variable.isQuestion() && variable.questionId === questionId
          })
        }) || null
      )
    }

    function getQuestionLabel(question) {
      if (_.isFunction(question.getTitleLabel)) {
        return question.getTitleLabel({ number: true })
      }
      return 'Q' + question.getNumber() + ': ' + question.title
    }

    function getQuestionOptionCount(question, existing) {
      if (existing) return existing.getOptions(question).length
      return (question.choices || []).length
    }

    function hasNothingToOffer() {
      return !ctrl.items.length
    }

    function isEverythingUsed() {
      if (!ctrl.items.length) return false

      return _.every(ctrl.items, function(item) {
        return !!item.reason
      })
    }

    function matchesQuery(item) {
      if (!ctrl.query) return true

      var haystack = (item.label || '').toLowerCase()
      return haystack.indexOf(ctrl.query.toLowerCase()) !== -1
    }

    function toggle(item) {
      if (item.reason) return

      item.selected = !item.selected
      refresh()
    }

    function buildTagVariable() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="quota-tag-variable-dialog__dialog">',
          '<quota-tag-variable-dialog ',
            'tags="tags" ',
            'used-tag-owners="usedTagOwners" ',
            'on-add="dialog.close($variable)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]

      glDialog
        .show({
          template: template.join(' '),
          clickOutsideToClose: false,
          escapeToClose: true,
          locals: {
            tags: ctrl.surveyTags || [],
            usedTagOwners: getUsedTagOwners(),
          },
        })
        .then(function(variable) {
          ctrl.items.push(makeTagItem(variable))
          refresh()
        })
        .catch(_.noop)
    }

    function getUsedTagOwners() {
      var owners = {}

      _.each(ctrl.plan ? ctrl.plan.getQuotas() : [], function(quota) {
        if (quota.id === ctrl.quota.id) return

        _.each(quota.variables, function(variable) {
          if (!variable.isTag()) return
          _.each(variable.options, function(option) {
            owners[option.tag] = variable.displayName
          })
        })
      })

      _.each(ctrl.items, function(item) {
        if (!item.selected || !item.variable || !item.variable.isTag()) return

        _.each(item.variable.options, function(option) {
          owners[option.tag] = item.variable.displayName
        })
      })

      return owners
    }

    function refresh() {
      var selected = getSelectedItems()

      ctrl.derivedName = getDerivedName(getSelectedVariables(selected))
      ctrl.footer = getFooter(selected)
    }

    function getSelectedItems() {
      return _.filter(ctrl.items, 'selected')
    }

    function getSelectedVariables(selected) {
      return (selected || getSelectedItems()).map(function(item) {
        if (item.variable) return item.variable

        var variable = new QuotaVariable()
        variable.type = QuotaVariable.Types.QUESTION
        variable.questionId = item.question.id

        item.variable = variable

        return variable
      })
    }

    function getDerivedName(variables) {
      var probe = new QuotaDefinition()

      probe.mode = ctrl.quota.mode
      probe.variables = variables

      return probe.getDerivedName(ctrl.questions)
    }

    function getCellTotal() {
      var selected = getSelectedItems()
      if (!selected.length) return 0

      var counts = _.map(selected, 'optionCount')

      return ctrl.quota.isInterlocked()
        ? counts.reduce(function(product, count) {
            return product * count
          }, 1)
        : _.sum(counts)
    }

    function getFooter(selected) {
      if (!selected.length) return 'No variables selected'

      var counts = _.map(selected, 'optionCount')
      var interlocked = ctrl.quota.isInterlocked()
      var total = getCellTotal()
      var cells = total + (total === 1 ? ' cell' : ' cells')

      if (counts.length === 1) return cells
      return counts.join(interlocked ? ' × ' : ' + ') + ' = ' + cells
    }

    function getError() {
      if (getTypedName().length > MAX_NAME_LENGTH) {
        return 'Keep the name to ' + MAX_NAME_LENGTH + ' characters or fewer.'
      }
      if (getCellTotal() > MAX_CELLS) {
        return (
          'That would create ' +
          getCellTotal() +
          ' cells. Keep it under ' +
          MAX_CELLS +
          ' — try fewer variables, or split this into separate quotas.'
        )
      }
      return null
    }

    function canApply() {
      return !!getSelectedItems().length && !getError()
    }

    function getChange() {
      var next = getSelectedVariables()
      var previous = ctrl.quota.variables

      return {
        variables: next,
        added: _.difference(next, previous),
        removed: _.difference(previous, next),
      }
    }

    function apply() {
      if (!canApply()) return

      var change = getChange()

      if (!change.added.length && !change.removed.length) return commit(change)

      var reset = getResetWarning(change)
      if (reset) {
        confirm(reset).then(function() {
          commit(change)
        })
        return
      }

      var zeroStart = getZeroStartWarning(change)
      if (zeroStart) {
        confirm(zeroStart).then(function() {
          commit(change)
        })
        return
      }

      commit(change)
    }

    function confirm(warning) {
      return glDialog.confirm(warning.title, warning.message, {
        locals: {
          closeText: warning.confirmLabel,
          cancelText: 'Cancel',
        },
      })
    }

    function commit(change) {
      ctrl.onApply({
        $result: {
          name: getResolvedName(change.variables),
          variables: change.variables,
          added: change.added,
          removed: change.removed,
        },
      })
    }

    function getResolvedName(variables) {
      var typed = getTypedName()

      if (!typed) return getDerivedName(variables)
      if (typed === originalDerivedName) return getDerivedName(variables)

      return typed
    }

    function getTypedName() {
      return (ctrl.name || '').trim()
    }

    function shouldWarn() {
      return ctrl.responseCount > 0
    }

    function getResetWarning(change) {
      if (!ctrl.quota.isInterlocked()) return null

      var targetCount = getTargetCount()
      if (!targetCount) return null

      // a broken quota yields no cells, so achieved is 0 and the targets-only message is the one that fires
      var achieved = shouldWarn() ? getQuotaAchieved() : 0

      if (!achieved) {
        return {
          title: getResetTitle(change),
          message: [
            'This quota currently holds ' +
              pluralise(targetCount, 'target', 'targets') +
              '. Changing which variables it crosses creates a different set of ' +
              'cells, so the targets cannot be carried across.',
            'Targets you re-enter are fine.',
          ].join('\n\n'),
          confirmLabel: getResetConfirmLabel(change, targetCount),
        }
      }

      return {
        title: getResetTitle(change),
        message: [
          'This quota currently holds ' +
            pluralise(targetCount, 'target', 'targets') +
            ' and ' +
            pluralise(achieved, 'collected response', 'collected responses') +
            '. Changing which variables it crosses creates a different set of ' +
            'cells, so the targets cannot be carried across.',
          'Targets you re-enter are fine. The collected counts are a different ' +
            'matter: they stop being counted here, and if you later come back to ' +
            'exactly these variables they may all reattach - missing everything ' +
            'collected in between. To be sure of a clean count, delete this quota ' +
            'and create it again.',
        ].join('\n\n'),
        confirmLabel: getResetConfirmLabel(change, targetCount),
      }
    }

    function getResetTitle(change) {
      var added = change.added
      var removed = change.removed

      if (added.length && removed.length) {
        return 'Changing these variables will clear this quota'
      }

      if (added.length === 1) {
        return (
          'Adding "' + getVariableName(added[0]) + '" will clear this quota'
        )
      }

      if (added.length) {
        return 'Adding ' + added.length + ' variables will clear this quota'
      }

      if (removed.length === 1) {
        return (
          'Removing "' + getVariableName(removed[0]) + '" will clear this quota'
        )
      }

      return 'Removing ' + removed.length + ' variables will clear this quota'
    }

    function getResetConfirmLabel(change, targetCount) {
      var verb =
        change.added.length && change.removed.length
          ? 'Change variables'
          : change.added.length
          ? change.added.length === 1
            ? 'Add variable'
            : 'Add variables'
          : change.removed.length === 1
          ? 'Remove variable'
          : 'Remove variables'

      if (!targetCount) return verb

      return verb + ' and clear ' + pluralise(targetCount, 'target', 'targets')
    }

    function getZeroStartWarning(change) {
      if (!shouldWarn()) return null

      var interlocked = ctrl.quota.isInterlocked()
      var zeroStarting = _.filter(change.added, function(variable) {
        return interlocked || variable.isQuestion()
      })
      if (!zeroStarting.length) return null

      var second = interlocked
        ? 'Every cell of an interlocked quota is counted this way, including ' +
          'cells built from tags.'
        : 'Rows built from tags are different: they count on the tag itself, so ' +
          'they include past responses immediately.'

      return {
        title: getZeroStartTitle(zeroStarting),
        message: [
          'Your survey has already collected ' +
            pluralise(ctrl.responseCount, 'response', 'responses') +
            '. These cells are counted using new tags attached at response ' +
            'time, so responses collected before now cannot be counted into ' +
            'them — they start at 0.',
          second,
        ].join('\n\n'),
        confirmLabel:
          zeroStarting.length === 1 ? 'Add variable' : 'Add variables',
      }
    }

    function getZeroStartTitle(zeroStarting) {
      if (zeroStarting.length === 1) {
        return (
          '"' +
          getVariableName(zeroStarting[0]) +
          '" will start counting from now'
        )
      }
      return 'These variables will start counting from now'
    }

    function getVariableName(variable) {
      if (variable.isTag()) return variable.displayName
      var question = _.find(ctrl.questions, { id: variable.questionId })
      return question ? getQuestionLabel(question) : 'this variable'
    }

    function getQuotaAchieved() {
      var counts = ctrl.tagCounts || {}
      return _.sumBy(
        quotaCellsService.getCells(ctrl.quota, ctrl.questions),
        function(cell) {
          return counts[cell.counterName] || 0
        }
      )
    }

    function getTargetCount() {
      if (!ctrl.plan) return 0
      return _.keys(ctrl.plan.targetSets[0].targets[ctrl.quota.id] || {}).length
    }
  }
})()
